import { Card, CardBody } from "@/components/ui/card";
import { VideoInsight } from "@/api/studio/insights/types/insight.type";
import { getThumbnailImage } from "@/features/reports/utils/get-thumbnail-image";
import { VideoMetricRow } from "@/features/reports/components/video-metric-row";

/* Prop Types */
interface VideoReportCardProps {
  insight: VideoInsight;
  isTopScore: boolean;
  projectId: string;
  studyId: string;
}

/**
 * VideoReportCard component
 *
 * Renders a single video's report card: thumbnail, asset title, the Attention score as a
 * percentage, and the Hook / Visual ease / Hold sub-metrics as coloured band rows.
 */
export const VideoReportCard = ({ insight, isTopScore, projectId, studyId }: VideoReportCardProps) => {
  /* Consts */
  const { attention } = insight.metrics;

  /* Render */
  return (
    <Card imageUrl={getThumbnailImage(insight.key, 300, 300, projectId, studyId)} imgFit="cover" winner={isTopScore} size="xlarge">
      <CardBody className="flex flex-col gap-4 px-6 py-5">
        <p className="font-semibold truncate text-sm text-base-content/60 pb-2">{insight.assetName}</p>

        <div className="flex items-center justify-between text-base font-medium">
          <h3>Attention</h3>
          <h2>{Math.round(attention.score)}%</h2>
        </div>

        <div className="flex flex-col gap-4">
          <VideoMetricRow label="Hook" score={attention.hook} />
          <VideoMetricRow label="Visual ease" score={attention.visualEase} />
          <VideoMetricRow label="Hold" score={attention.hold} />
        </div>
      </CardBody>
    </Card>
  );
};
